import React, { useCallback, useState } from "react";
import { Link } from "../link";
import User from "../user";
import Cart from "../cart";
import Logo from "../../icons/logo.svg";
import SearchIcon from "../../icons/cerca.svg";
import { normalizeRelativePath } from "../../utility/paths";
import LanguageDropdown from "./language-dropdown";
import SupportMenu from "./support-menu";
import useClickOut from "../../hooks/use-click-out";
import classNames from "classnames";

const NO_SALESFORCE = process.env.GATSBY_NO_SALESFORCE;
const externalPDPShopify = process.env.GATSBY_SHOPIFY_EXTERNAL_PDP || false;

const HeaderTop = ({
  toggleHamburger,
  labelManagerLabels,
  siteTitle,
  hasEcommerce,
  config,
  search,
  toggleSearch,
  newTopLeftMenu,
  newTopRightMenu,
  menuConfig,
}) => {
  const [supporto, setSupporto] = useState(false);
  const toggleSupporto = useCallback(() => setSupporto((value) => !value), []);
  const supportoRef = useClickOut(supporto, setSupporto);
  return (
    <div className="new-header-top">
      <div className="container-fluid wrapper">
        <div className="row align-items-center" style={{ position: "relative" }}>
          <div className="col-4">
            <div className="d-lg-none">
              <button
                className="hamburger"
                onClick={toggleHamburger}
                aria-label={labelManagerLabels.menu}
              >
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </button>
            </div>
            {newTopLeftMenu && newTopLeftMenu?.navigationMenuItems?.length > 0 && (
              <div className="d-none d-lg-flex">
                {newTopLeftMenu.navigationMenuItems.map((element, index) => (
                  <div className="d-flex" key={index}>
                    {(element?.content?.liferayFields?.title ||
                      (!!element?.useCustomName && element?.name)) && (
                      <>
                        {element?.content?.slug ? (
                          <Link
                            to={normalizeRelativePath(element.content.slug)}
                            target={
                              element?.content?.target && element?.content?.target?.length > 0
                                ? element.content.target[0]
                                : ""
                            }
                            key={index}
                            className="new-header-top__page-link"
                          >
                            {!!element?.useCustomName && element?.name
                              ? element.name
                              : element.content?.liferayFields?.title}
                          </Link>
                        ) : element?.content?.externalLink ? (
                          <a
                            className="new-header-top__page-link"
                            href={element.content.externalLink}
                            target={
                              element?.content?.target && element?.content?.target?.length > 0
                                ? element.content.target[0]
                                : ""
                            }
                            rel={
                              element.content.target?.[0] === "_blank" ? "noopener noreferrer" : ""
                            }
                          >
                            {!!element?.useCustomName && element?.name
                              ? element.name
                              : element.content?.liferayFields?.title}
                          </a>
                        ) : null}
                      </>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="col-4">
            <div className="logo text-center">
              <Link className="logo__link" to="/" aria-label={siteTitle}>
                <Logo />
              </Link>
            </div>
          </div>
          <div className="col-4 position-static">
            <div className="d-flex justify-content-end">
              {newTopRightMenu?.navigationMenuItems?.length && (
                <button
                  onClick={toggleSupporto}
                  className={classNames(
                    "utility-link__btn utility-link__btn--new-menu d-none d-lg-block",
                    supporto && "open"
                  )}
                >
                  {labelManagerLabels.support}
                </button>
              )}
              {menuConfig?.languageActive && (
                <LanguageDropdown className="d-none d-lg-block ml-4" />
              )}
              {(hasEcommerce || config?.shopLink) && !externalPDPShopify && (
                <Cart shopLink={config?.shopLink} />
              )}
              {!NO_SALESFORCE && menuConfig?.ciamActive && <User />}
              {menuConfig?.searchActive && (
                <div className="utility-link">
                  <button
                    className={`utility-link__btn utility-link__btn--icon${search ? " open" : ""}`}
                    onClick={toggleSearch}
                    aria-label={labelManagerLabels.search}
                  >
                    <SearchIcon />
                  </button>
                </div>
              )}
            </div>
          </div>
          <SupportMenu
            className="d-none d-lg-block"
            supportoRef={supportoRef}
            supporto={supporto}
            newTopRightMenu={newTopRightMenu}
          />
        </div>
      </div>
    </div>
  );
};

export default HeaderTop;
